import { HttpServer } from '@/services/server'
import { SearchRequest, AccessType } from './searchType'

declare const window: any

export class SearchModel {
    public static async fetchSearchResult(): Promise<SearchRequest> {
        try {
            const Access: AccessType = await new Promise((resolve) =>
                window.Session.getToken(resolve)
            )
            if (Access) {
                const params = {
                    sex: Access.account.sex
                }
                const searchResult = await HttpServer.searchhotConfig(params)
                if (searchResult.data.code === 0) {
                    return searchResult.data.data
                }
            }
        } catch (err) {
            console.log(err)
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeSearchPage/searchModel.ts